import {BasicCriteria} from '../../../../allkey/framework/parameters/BasicCriteria';

export class ProcedureCriteria extends BasicCriteria {}

